async function emailFormSubmit(e) {
    e.preventDefault();
    const url = e.target.getAttribute('action');
    const data = new FormData(e.target);

    data.set('message', rich_editor.activeEditor.getContent())

    if (e.target.file?.files?.length > 0) {
        data.set('file', e.target.file.files[0], e.target.file.files[0].name);
    }

    try {
        const response = await axios.post(url, data, {
            headers: {
                'Content-Type': 'multipart/form-data'
            }
        });
        toast.success(response.data.message)
    } catch (err) {
        toast.error('Ocorreu um erro ao processar sua solicitação, tente novamente.');
    }
}

window.emailFormSubmit = emailFormSubmit;
